import React, { Component } from "react";
import {
  Layout,
  Menu,
  Icon,
  Breadcrumb,
  BackTop,
  PageHeader,
  Spin,
} from "antd";
import { withRouter } from "react-router-dom";
import { COLORS } from "./theme";
import { getSliderState, setSliderState } from "../lib/util";

const { Header, Content, Footer, Sider } = Layout;

class CustomPageHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: this.props.initialTitle,
      onBackPressed: null,
      active_state: null,
      back_path: null,
    };
  }
  assignTitle = (title, onBackPressed) => {
    this.setState({ title });
  };
  overrideBack = (path, given_state, callback_function) => {
    this.setState({
      onBackPressed: callback_function,
      active_state: given_state,
      back_path: path,
    });
  };
  render() {
    const { title, active_state, onBackPressed, back_path } = this.state;

    let onback = null;
    if (back_path != null && typeof back_path === "string") {
      onback = () => {
        if (back_path == "back") {
          this.props.history.goBack();
        } else {
          this.props.history.push(back_path);
        }
      };
    }
    console.log("onback", onback);
    return (
      <PageHeader
        style={{
          // position :'fixed',
          // backgroundColor:'red',
          paddingTop: 8,
          paddingBottom: 8,
          width: "100%",
        }}
        title={
          title == "loading" ? (
            <Spin />
          ) : title == "error" ? (
            this.props.initialTitle
          ) : (
            title
          )
        }
        // title={<span></span>}
        // tags={this.props.tags}
        // onBack={()=>{
        //     // this.props.history.push('./')
        //     this.props.history.goBack()
        // }}

        onBack={onback}
        // breadcrumb={{ ...this.props.pageRoutes, separator: ">" }}
      />
    );
  }
  componentDidMount() {
    typeof this.props.onRef === "function" && this.props.onRef(this);
  }
  componentWillUnmount() {
    typeof this.props.onRef === "function" && this.props.onRef(undefined);
  }
}
class MainLayout extends Component {
  constructor(props) {
    super(props);

    let width = window.innerWidth;

    this.state = {
      sliderCollapse: width < 500 ? true : getSliderState(),
      isMobile: width < 500 ? true : false,
      topBarVisibility: true,
    };
  }

  changeSliderState = (val) => {
    this.setState(
      {
        sliderCollapse: val ? true : false,
      },
      () => {
        setSliderState(this.state.sliderCollapse);
        try {
          window.header.assignSliderState(this.state.sliderCollapse);
        } catch (e) {}
      }
    );
  };

  toggleTopBar = (visibility) => {
    console.log("changing visibility", visibility);
    this.setState({
      topBarVisibility: visibility,
    });
  };

  toggleSlider = (callback) => {
    let new_state;
    this.setState(
      {
        sliderCollapse: !this.state.sliderCollapse,
      },
      () => {
        setSliderState(this.state.sliderCollapse);
        typeof callback === "function" && callback(this.state.sliderCollapse);
      }
    );
  };

  render() {
    const { sliderCollapse, topBarVisibility } = this.state;
    return (
      <Layout>
        <Sider
          theme="light"
          trigger={null}
          // reverseArrow={true}
          collapsed={sliderCollapse}
          collapsible
          onCollapse={() => {
            this.setState({
              sliderCollapse: !sliderCollapse,
            });
          }}
          width={250}
          collapsedWidth={0}
          className="side-scroll"
          style={{
            height: `calc(100vh - 66px)`,
            position: "fixed",
            backgroundColor: COLORS.primary,
            left: 0,
            marginTop: 6,
            marginBottom: 6,
            borderTopRightRadius: 10,
            borderBottomRightRadius: 10,
            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
            paddingTop: "1vh",
            paddingBottom: "1vh",
            paddingLeft: sliderCollapse ? 0 : 0,
            paddingRight: sliderCollapse ? 0 : 0,
            zIndex: 2,
            overflowY: "scroll",
            transition: "all .4s ease-in-out",
            top: topBarVisibility ? 56 : 0,
          }}
        >
          {/* <span className={'ant-layout-sider-zero-width-trigger ant-layout-sider-zero-width-trigger-left custom-trigger'} 
                    style={{
                        backgroundColor:this.props.backgroundColor
                    }}
                    onClick={() => {
                        this.changeSliderState(!sliderCollapse)
                        // this.setState({
                            // sliderCollapse: !sliderCollapse
                        // })
                    }}>
                        <Icon  type={sliderCollapse?'caret-right':'caret-left'} />
                    </span> */}
          {/* <div className='no-scroll-bar'
                    onClick={(e)=>{
                        // console.log("clicked dom",e.target)
                    }}
                        style={{
                            overflowY: 'scroll',
                            height: '100%',
                            scrollbarWidth: 0,
                            
                        }}> */}
          {this.props.sliderContent}
          {/* </div> */}
        </Sider>
        <div
          style={{
            paddingLeft: this.state.isMobile
              ? 0
              : (this.state.sliderCollapse ? 0 : 250) + 0,
            transition: "all .4s ease-in-out",
            // width: 'calc(100vh - 150px)',
            width: "100%",
            // overflowY:'hidden'
          }}
        >
          {this.props.mainContent}
        </div>
      </Layout>
    );
  }
  componentDidMount() {
    typeof this.props.onRef === "function" && this.props.onRef(this);
    window.side_content = this;
  }

  componentWillUnmount() {
    typeof this.props.onRef === "function" && this.props.onRef(undefined);
    window.side_content = null;
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.location && prevProps.location && window.innerWidth < 500) {
      if (this.props.location.pathname != prevProps.location.pathname) {
        this.setState({
          sliderCollapse: true,
        });
      }
    }
  };
}

export default withRouter(MainLayout);
